<!-- <select >
@for (item of items; track $index) {
  <option [ngValue]="item.value">
    {{ item.description }}
  </option>
}
</select> -->
<!-- <ideapa-select
[formControl]="operatorControl"
[items]="items"
[clearable]="false"
>
</ideapa-select> -->

@if (!readOnly) {
  <ng-select
    class="custom-operators-select"
    [items]="items"
    [bindLabel]="'description'"
    [ngModel]="selectedItem"
    [appendTo]="'body'"
    [clearable]="false"
    [searchable]="false"
    (ngModelChange)="setOperator($event)"
    >
    <ng-template ng-option-tmp let-item="item">
      <div class="small-option">{{ item.description }}</div>
    </ng-template>
  </ng-select>
}

@if (readOnly) {
  <div class="text-primary selected">
    {{ selectedItem?.description }}
  </div>
}
